export default __webpack_public_path__ + "static/media/maintenance.27af48fe.svg";